(function ($) {
  featBenfSectionFormatterV1 = {
    formatter: $('.features-and-benefits-formatter-v1')
  };

  Drupal.behaviors.featBenfSectionFormatterV1 = {
    get: function (key) {
      return featBenfSectionFormatterV1[key];
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);

        // Find 3rd (last) column of each row and add "col3 last" CSS classes to set its margin-right to 0
        thisFormatter.find('.outer-wrap').find('.featbenf_section-row-v1').each(function (i) {
          var row = $(this);

          row.filter(function () {
            return (i + 1) % 3 === 0;
          }).addClass('col3 last');
        });
      });
    }
  };
})(jQuery);
